import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Prescription } from '../../models/electronic-prescription/prescription';
import { UserApiService } from '../../services/user-api.service';
import { LoggerService } from 'src/app/services/logger.service';
import { ApiRequestModel } from 'src/app/models/api-request-model';
import { PrescriptionSelectDrug } from '../../models/electronic-prescription/prescription-select-drug';
import { PrescriptionDrug } from '../../models/electronic-prescription/prescription-drug';
import { PrescriptionDrugStock } from '../../models/electronic-prescription/prescription-drug-stock';
import * as _ from 'lodash-es';
import { FormControl, FormGroup } from '@angular/forms';
import {
  PCTableInputModel,
  PCTableOutputModel,
} from '../../models/pc-table-input-model';
import { TabelPaging } from '../../interfaces/table';
import { PCSearchRequestModel } from '../../models/pc-search-request-model';
import { CustomizeResponseService } from '../../services/customize-response.service';
import { debounceTime } from 'rxjs/operators';
import { LoggingGroupModel } from 'src/app/models/logging-model';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { PrescriptionDrugMessages } from '../../models/electronic-prescription/prescription-drug-messages';
import { Referral } from '../../models/electronic-prescription/referral';
import { Recept } from '../../models/electronic-prescription/recept';
import { ReferralRequest } from '../../models/electronic-prescription/referral-request';
import { SaleFactorType } from 'src/app/enum/sale-factor-type';
import { PrescriptionPageDatabase } from '../../models/electronic-prescription/prescription-page-database';
import { GetActivePrescriptionViewModel } from '../../models/electronic-prescription/get-active-prescription-view-model';
import { TaminService } from '../../services/tamin.service';

@Component({
  selector: 'app-electronic-prescription',
  templateUrl: './electronic-prescription.component.html',
  styleUrls: ['./electronic-prescription.component.css'],
})
export class ElectronicPrescriptionComponent {
  // public boxList: boolean[] = [true, true, true, true];

  // public boxIdList: string[] = [
  //   'input-prescription-information',
  //   'prescription-information',
  //   'prescription-details',
  //   'select-prescription-details',
  // ];

  // private salamatData:any[]=[
  //   {
  //     code: "225750008",
  //     description: "هر 2 ساعت",
  //     title: "Every two hours"
  //   },
  //   {
  //     code: "225753005",
  //     description: "هر 3 ساعت",
  //     title: "Every three hours"
  //   },
  //   {
  //     code: "225756002",
  //     description: "هر 4 ساعت",
  //     title: "Every four hours"
  //   },
  //   {
  //     code: "307468000",
  //     description: "هر 6 ساعت",
  //     title: "Every six hours"
  //   },
  //   {
  //     code: "307469008",
  //     description: "هر 8 ساعت",
  //     title: "Every eight hours"
  //   },
  //   {
  //     code: "307470009",
  //     description: "هر 12 ساعت",
  //     title: "Every twelve hours"
  //   },
  //   {
  //     code: "396126004",
  //     description: "هر 36 ساعت",
  //     title: "Every thirty six hours"
  //   },
  //   {
  //     code: "229797004",
  //     description: "روزی یک عدد",
  //     title: "Once a day"
  //   },
  //   {
  //     code: "225760004",
  //     description: "یک روز در میان",
  //     title: "Every other day"
  //   },
  //   {
  //     code: "225760004",
  //     description: "یک شب در میان",
  //     title: "Every other night"
  //   },
  //   {
  //     code: "229799001",
  //     description: "2 بار در روز",
  //     title: "Twice a day"
  //   },
  //   {
  //     code: "229798009",
  //     description: "3 بار در روز",
  //     title: "Three times a day"
  //   },
  //   {
  //     code: "307439001",
  //     description: "4 بار در روز",
  //     title: "Four times a day"
  //   },
  //   {
  //     code: "307452006",
  //     description: "هر 10 روز",
  //     title: "Every ten days"
  //   },
  //   {
  //     code: "1511000175108",
  //     description: "هر 28 روز",
  //     title: "Every twenty eight days"
  //   },
  //   {
  //     code: "225768006",
  //     description: "هر ساعت",
  //     title: "Every hour"
  //   },
  //   {
  //     code: "14497002",
  //     description: "هر هفته",
  //     title: "Every week"
  //   },
  //   {
  //     code: "89185003",
  //     description: "هر ماه",
  //     title: "Every month"
  //   },
  //   {
  //     code: "307455008",
  //     description: "هر سال",
  //     title: "Every year"
  //   },
  //   {
  //     code: "307472001",
  //     description: "هر صبح",
  //     title: "Every morning"
  //   },
  //   {
  //     code: "307473006",
  //     description: "هر شب",
  //     title: "Every night"
  //   },
  //   {
  //     code: "20050000",
  //     description: "هر دو هفته",
  //     title: "Every other week"
  //   },
  //   {
  //     code: "51199007",
  //     description: "هر سه هفته",
  //     title: "Every three weeks"
  //   },
  //   {
  //     code: "229800002",
  //     description: "دو روز در هفته",
  //     title: "Twice a week"
  //   },
  //   {
  //     code: "3015006",
  //     description: "هر سه ماه",
  //     title: "Every three months"
  //   },
  //   {
  //     code: "307456009",
  //     description: "هر شش ماه",
  //     title: "Every six months"
  //   },
  //   {
  //     code: "307446005",
  //     description: "پنج روز در هفته",
  //     title: "Five days a week"
  //   },
  //   {
  //     code: "422135004",
  //     description: "طبق دستور",
  //     title: "As directed"
  //   },
  //   {
  //     code: "307446005",
  //     description: "در مواقع لازم",
  //     title: "As needed"
  //   }
  // ];

  // public referral: Referral;
  // public referralRequest: ReferralRequest;
  // public prescriptionIndex?: number;
  // public loading: boolean = false;
  // public listLoading: boolean = false;
  // public drugSearchForm: FormGroup;
  // public modalIsOpen: boolean = false;
  // public receptModalIsOpen: boolean = false;
  // public searchData?: PCTableInputModel;
  // public searchPaging?: TabelPaging;
  // public searchRequestModel: PCSearchRequestModel;
  // public selectedIndex: number = -1;
  // public searchItem: string = '';
  // public editItem?: PrescriptionDrug = undefined;
  // public activeSearch: boolean = true;
  // public modalSuccessConfirm: boolean = false;
  // public messageModalActive?: PrescriptionDrugMessages;
  // public recept: any;

  // public uploadBarcodeItem?: PrescriptionSelectDrug;

  // public pageDatabase: PrescriptionPageDatabase;
  // public getBackendRequest: GetActivePrescriptionViewModel;

  // @ViewChild('itemMessage') itemMessageModal!: NgbPopover;
  // @ViewChild('ScanBarcodeModal') ScanBarcodeModal!: NgbPopover;

  // constructor(
  //   private apiService: UserApiService,
  //   private logger: LoggerService,
  //   private modalService: NgbModal,
  //   private renderer: Renderer2,
  //   private taminService: TaminService,
  //   private responseService: CustomizeResponseService
  // ) {
  //   this.pageDatabase = new PrescriptionPageDatabase();
  //   this.getBackendRequest = new GetActivePrescriptionViewModel(0);

  //   this.referral = new Referral();
  //   this.referralRequest = new ReferralRequest();
  //   this.searchRequestModel = new PCSearchRequestModel();
  //   this.drugSearchForm = new FormGroup({
  //     drugBrandName: new FormControl(''),
  //   });

  //   this.renderer.listen('window', 'keyup', (e: any) => {
  //     if (e.key == 'F2' || e.key == "PrintScreen") {
  //       this.print();
  //     }
  //   });
  // }

  // public ngOnInit(): void {
  //   this.drugSearchForm
  //     .get('drugBrandName')
  //     ?.valueChanges.pipe(debounceTime(1000))
  //     .subscribe((value) => {
  //       if (this.activeSearch) {
  //         this.searchDrug(value);
  //       } else {
  //         this.activeSearch = true;
  //       }
  //     });
  // }

  // private openBox(index: number) {
  //   const elementItem = document.getElementById(this.boxIdList[index]);
  //   if (elementItem == null) {
  //     return;
  //   }

  //   elementItem.classList.remove('hide');

  //   setTimeout(() => {
  //     this.boxList[index] = true;
  //   }, 1000);
  // }

  // private closeBox(index: number) {
  //   this.boxList[index] = false;

  //   setTimeout(() => {
  //     const elementItem = document.getElementById(this.boxIdList[index]);
  //     if (elementItem == null) {
  //       return;
  //     }

  //     elementItem.classList.add('hide');
  //   }, 500);
  // }

  // public openCloseBox(index: number) {
  //   if (this.boxList[index]) {
  //     this.closeBox(index);
  //   } else {
  //     this.openBox(index);
  //   }
  // }

  // public getMockData() {
  //   try {
  //     const mockUrl = `BuyFactor/MockData`;

  //     if (!this.apiService.tokenValidation(new ApiRequestModel(mockUrl))) {
  //       return;
  //     }

  //     this.loading = true;

  //     this.apiService.getSingleItem(new ApiRequestModel(mockUrl)).subscribe(
  //       (result) => {
  //         this.logger.addResponseLog(mockUrl, result, 'postItem');
  //         if (result.succeeded) {
  //           this.mapDataToReferral(result.data);
  //         } else {
  //           this.logger.addBackEndMessage(result);
  //         }
  //         this.loading = false;
  //       },
  //       (error) => {
  //         this.apiService.AddErrorLog(error);
  //         this.loading = false;
  //       },
  //       () => {}
  //     );
  //   } catch (e) {
  //     this.logger.addException(e, true);
  //     this.loading = false;
  //   }
  // }

  // public mapDataToReferral(result: any) {
  //   this.referral = result;
  //   this.referral.prescriptions = result.prescriptions.map((current) => ({
  //     prescriptionId: current.prescriptionId,
  //     drugs: current.drugs.map((secondCurrent) => ({
  //       id: secondCurrent.id,
  //       organizationId: secondCurrent.organizationId,
  //       genericName: secondCurrent.genericCodeString,
  //       genericCode: secondCurrent.genericCode,
  //       brandName: secondCurrent.brandName,
  //       erxCode: secondCurrent.erxCode,
  //       consumption: secondCurrent.consumption,
  //       requestCount: secondCurrent.requestCount,
  //       maxCoveredCount: secondCurrent.maxCoveredCount,
  //       shouldSendToEsalat: secondCurrent.shouldSendToEsalat,
  //       checkDeliverCode:
  //         secondCurrent.checkDeliverCode == null
  //           ? undefined
  //           : secondCurrent.checkDeliverCode,
  //       organizationSharePrice:
  //         result.saleFactorType == 4
  //           ? secondCurrent.orgAmount
  //           : secondCurrent.organizationSharePrice,
  //       messages: secondCurrent.messages,
  //       stock: {
  //         stockItemId: secondCurrent.stock.stockItemId,
  //         stockId: secondCurrent.stock.stockId,
  //         drugId: secondCurrent.stock.drugId,
  //         brandName: secondCurrent.stock.brandName,
  //         expireDate: secondCurrent.stock.expireDate,
  //         drugPackage: secondCurrent.stock.drugPackage,
  //         stockName: secondCurrent.stock.stockName,
  //         inventoryCount: secondCurrent.stock.inventoryCount,
  //         saleCount: secondCurrent.stock.saleCount,
  //         price: secondCurrent.stock.price,
  //         patientSharePrice:
  //           secondCurrent.stock.price -
  //           (result.saleFactorType == 4
  //             ? secondCurrent.orgAmount
  //             : secondCurrent.organizationSharePrice),
  //       },
  //       activeSearch: false,
  //       isSelected: false,
  //     })),
  //     originalDrugs: _.cloneDeep(
  //       current.drugs.map((secondCurrent) => ({
  //         id: secondCurrent.id,
  //         organizationId: secondCurrent.organizationId,
  //         genericName: secondCurrent.genericName,
  //         genericCode: secondCurrent.genericCode,
  //         brandName: secondCurrent.brandName,
  //         erxCode: secondCurrent.erxCode,
  //         consumption: secondCurrent.consumption,
  //         requestCount: secondCurrent.requestCount,
  //         maxCoveredCount: secondCurrent.maxCoveredCount,
  //         shouldSendToEsalat: secondCurrent.shouldSendToEsalat,
  //         organizationSharePrice: secondCurrent.organizationSharePrice,
  //         messages: secondCurrent.messages,
  //         stock: secondCurrent.stock,
  //         activeSearch: false,
  //         isSelected: false,
  //       }))
  //     ),
  //   }));
  //   this.referral.isShow = true;
  // }

  // public clearPage() {
  //   this.referral = new Referral();
  // }

  // public getPrescription(presType: SaleFactorType) {
  //   try {
  //     this.loading = true;
  //     this.clearPage();

  //     this.getBackendRequest = new GetActivePrescriptionViewModel(presType);
  //     if (
  //       this.referralRequest.patientNationalCode == null ||
  //       this.referralRequest.trackingCode == null
  //     ) {
  //       this.logger.addInfo("Let's get Fake Data", false);
  //       this.getMockData();
  //       return;
  //     }
  //     //TODO : Return Top With Validation Error
  //     if (presType == SaleFactorType.SalamatElectronicPrescription) {
  //       this.getSalamatPrescription();
  //     } else if (presType == SaleFactorType.TaminElectronicPrescription) {
  //       this.getTaminPrescription();
  //     }
  //   } catch (error) {
  //     this.logger.addError(error, false);
  //     this.loading = false;
  //     return;
  //   }
  // }

  // private getSalamatPrescription() {
  //   try {
  //     if (this.pageDatabase.salamatApiToken == '') {
  //       this.pageDatabase.salamatApiToken = undefined;
  //     }
  //     this.getBackendRequest.token = _.cloneDeep(
  //       this.pageDatabase.salamatApiToken
  //     );

  //     if (
  //       this.pageDatabase.citizenToken == '' ||
  //       this.referralRequest.patientNationalCode !=
  //         this.pageDatabase.citizenNationalCode
  //     ) {
  //       this.pageDatabase.citizenToken = undefined;

  //       this.pageDatabase.citizenNationalCode = _.cloneDeep(
  //         this.referralRequest.patientNationalCode
  //       );
  //     }
  //     this.getBackendRequest.citizenToken = _.cloneDeep(
  //       this.pageDatabase.citizenToken
  //     );

  //     this.getBackendRequest.nationalCode = _.cloneDeep(
  //       this.referralRequest.patientNationalCode
  //     );
  //     this.getBackendRequest.trackingCode = _.cloneDeep(
  //       this.referralRequest.trackingCode
  //     );

  //     this._getPrescriptionFromBackend();
  //   } catch (error) {
  //     this.logger.addError(error, false);
  //     this.loading = false;
  //     return;
  //   }
  // }

  // private getTaminPrescription() {
  //   try {
  //     if (this.pageDatabase.taminApiToken == '') {
  //       this.pageDatabase.taminApiToken = undefined;
  //     }

  //     if (this.pageDatabase.taminApiToken == undefined) {
  //       this.taminService
  //         .TaminLoginWithRedirect()
  //         .then((token) => {
  //           if (token.succeeded == true) {
  //             this.pageDatabase.taminApiToken = token.taminToken;
  //             this.getBackendRequest.token = _.cloneDeep(
  //               this.pageDatabase.taminApiToken
  //             );
  //             this.getBackendRequest.nationalCode = _.cloneDeep(
  //               this.referralRequest.patientNationalCode
  //             );
  //             this.getBackendRequest.trackingCode = _.cloneDeep(
  //               this.referralRequest.trackingCode
  //             );
  //             this._getPrescriptionFromBackend();
  //           } else {
  //             this.logger.addError(token.message, false);
  //             this.loading = false;
  //             return;
  //           }
  //         })
  //         .catch((error) => {
  //           this.logger.addError(error, false);
  //           this.loading = false;
  //           return;
  //         })
  //         .finally(() => {
  //           this.loading = false;
  //           return;
  //         });
  //     } else {
  //       this.getBackendRequest.token = _.cloneDeep(
  //         this.pageDatabase.taminApiToken
  //       );
  //       this.getBackendRequest.nationalCode = _.cloneDeep(
  //         this.referralRequest.patientNationalCode
  //       );
  //       this.getBackendRequest.trackingCode = _.cloneDeep(
  //         this.referralRequest.trackingCode
  //       );
  //       this._getPrescriptionFromBackend();
  //     }
  //   } catch (error) {
  //     this.logger.addError(error, false);
  //     this.loading = false;
  //     return;
  //   }
  // }

  // private _getPrescriptionFromBackend() {
  //   try {
  //     const taminUrl = `SaleElectronicPrescription/GetPrescription`;

  //     if (
  //       !this.apiService.tokenValidation(
  //         new ApiRequestModel(taminUrl, this.getBackendRequest)
  //       )
  //     ) {
  //       this.loading = false;
  //       return;
  //     }

  //     this.apiService
  //       .postItem(new ApiRequestModel(taminUrl, this.getBackendRequest))
  //       .subscribe(
  //         (result) => {
  //           if (
  //             this.getBackendRequest.saleFactorType ==
  //             SaleFactorType.SalamatElectronicPrescription
  //           ) {
  //             this.pageDatabase.salamatApiToken = result.data.token;
  //             this.pageDatabase.citizenNationalCode = result.data.citizenToken;
  //             result.data.prescriptions.forEach(prescription => {
  //               prescription.drugs.forEach(drug => {
  //                 const doctorOrder=this.salamatData
  //                 .find(current=>current.code==drug.consumptionSNOMEDCode&&
  //                   current.title==drug.consumption
  //                 );
  //                 if (doctorOrder!=null) {
  //                   drug.consumption=doctorOrder.description;
                    
  //                 }
  //               });
  //             });
  //           }

  //           if (result.succeeded == false) {
  //             this.logger.addBackEndMessage(result);
  //             this.loading = false;
  //             return;
  //           }

  //           this._getPrescriptionMessagesFromBackend(result.data);

  //           this.mapDataToReferral(result.data);

  //           this.loading = false;
  //         },
  //         (error) => {
  //           this.apiService.AddErrorLog(error);
  //           this.loading = false;
  //         },
  //         () => {
  //           this.loading = false;
  //         }
  //       );
  //   } catch (e) {
  //     this.logger.addException(e, true);
  //     this.loading = false;
  //     return;
  //   }
  // }

  // private _getPrescriptionMessagesFromBackend(result: any) {
  //   try {
  //     const url = `SaleElectronicPrescription/GetPrescriptionMessages`;

  //     if (!this.apiService.tokenValidation(new ApiRequestModel(url, result))) {
  //       return;
  //     }

  //     this.apiService.postItem(new ApiRequestModel(url, result)).subscribe(
  //       (result) => {
  //         if (
  //           this.getBackendRequest.saleFactorType ==
  //           SaleFactorType.SalamatElectronicPrescription
  //         ) {
  //           this.pageDatabase.salamatApiToken = result.data.token;
  //           this.pageDatabase.citizenNationalCode = result.data.citizenToken;
  //         }

  //         if (result.succeeded == false) {
  //           this.logger.addBackEndMessage(result);
  //           return;
  //         }

  //         this.mapDataToReferral(result.data);
  //       },
  //       (error) => {
  //         this.apiService.AddErrorLog(error);
  //       },
  //       () => {}
  //     );
  //   } catch (e) {
  //     this.logger.addException(e, true);
  //     return;
  //   }
  // }

  // public selectItem(drugIndex: number, presIndex: number) {
  //   try {
  //     if (this.prescriptionIndex == null) {
  //       this.prescriptionIndex = presIndex;
  //     }

  //     let prescription: Prescription =
  //       this.referral.prescriptions[this.prescriptionIndex];

  //     const drugItem = prescription.drugs[drugIndex];

  //     let selectItem = this.mapDetailToSelect(drugItem, drugItem.stock);

  //     if (prescription.selectDrug == null) {
  //       prescription.selectDrug = [];
  //     }
  //     prescription.selectDrug.push(selectItem);

  //     this.removeFromBaseList(drugIndex, this.prescriptionIndex);
  //   } catch (error) {
  //     this.logger.addError(error, false);
  //     return;
  //   }
  // }

  // private mapDetailToSelect(
  //   drugItem: PrescriptionDrug,
  //   stockItem: PrescriptionDrugStock
  // ): PrescriptionSelectDrug {
  //   try {
  //     let selectItem = new PrescriptionSelectDrug();

  //     let drugPackageCount: number =
  //       drugItem.stock.drugPackage == null ? 1 : drugItem.stock.drugPackage;

  //     drugPackageCount = drugPackageCount <= 0 ? 1 : drugPackageCount;

  //     selectItem.id = drugItem.id;
  //     selectItem.brandName = stockItem.brandName;
  //     selectItem.expireDate = stockItem.expireDate;
  //     selectItem.count = stockItem.saleCount == null ? 1 : stockItem.saleCount;
  //     selectItem.drugPackage = selectItem.count / drugPackageCount;
  //     selectItem.price = stockItem.price;
  //     selectItem.patientSharePrice = stockItem.patientSharePrice;
  //     selectItem.insuranceSharePrice = drugItem.organizationSharePrice;
  //     selectItem.organizationId = drugItem.organizationId;
  //     selectItem.stockItemId = drugItem.stock.stockItemId;
  //     selectItem.stockId = drugItem.stock.stockId;
  //     selectItem.drugId = drugItem.stock.drugId;
  //     selectItem.genericCode = drugItem.genericCode;
  //     selectItem.genericName = drugItem.genericName;
  //     selectItem.checkDeliverCode = drugItem.checkDeliverCode;

  //     return selectItem;
  //   } catch (error) {
  //     throw error;
  //   }
  // }

  // public selectAll(presIndex: number) {
  //   try {
  //     if (this.prescriptionIndex == null) {
  //       this.prescriptionIndex = presIndex;
  //     }

  //     let prescription: Prescription =
  //       this.referral.prescriptions[this.prescriptionIndex];
  //     let newDetailList: PrescriptionDrug[] = [];
  //     prescription.drugs.forEach((element) => {
  //       if (
  //         element.stock == null ||
  //         element.isSelected == true ||
  //         element.stock.saleCount == null ||
  //         element.stock.saleCount <= 0
  //       ) {
  //         newDetailList.push(element);
  //       } else if (element.messages.informationMessage.length > 0) {
  //         newDetailList.push(element);
  //       } else {
  //         if (prescription.selectDrug == null) {
  //           prescription.selectDrug = [];
  //         }
  //         prescription.selectDrug.push(
  //           this.mapDetailToSelect(element, element.stock)
  //         );
  //       }
  //     });

  //     prescription.drugs = newDetailList;
  //   } catch (error) {
  //     this.logger.addError(error, false);
  //     return;
  //   }
  // }

  // public deSelectItem(selectIndex: number) {
  //   try {
  //     if (this.prescriptionIndex == null) {
  //       this.logger.addError('خطایی رخ داده صفحه را به روز کنید ', false);
  //       return;
  //     }

  //     let prescription: Prescription =
  //       this.referral.prescriptions[this.prescriptionIndex];
  //     const thisItem = prescription.selectDrug[selectIndex];

  //     if (thisItem == null) {
  //       return;
  //     }

  //     const findOriginalItem = prescription.originalDrugs.find(
  //       (current) => current.id == thisItem.id
  //     );

  //     if (findOriginalItem == null) {
  //       return;
  //     }

  //     this.removeFromSaleFactor(selectIndex, this.prescriptionIndex);
  //   } catch (error) {
  //     this.logger.addError(error, false);
  //     return;
  //   }
  // }

  // public deSelectAll() {
  //   try {
  //     if (this.prescriptionIndex == null) {
  //       this.logger.addError('خطایی رخ داده صفحه را به روز کنید ', false);
  //       return;
  //     }

  //     let prescription: Prescription =
  //       this.referral.prescriptions[this.prescriptionIndex];
  //     const selectedLength = prescription.selectDrug.length;

  //     for (let index = 0; index < selectedLength; index++) {
  //       this.deSelectItem(0);
  //     }

  //     this.prescriptionIndex = undefined;
  //   } catch (error) {
  //     this.logger.addError(error, false);
  //     return;
  //   }
  // }

  // public openEdit(item: PrescriptionDrug, presIndex: number) {
  //   try {
  //     if (this.prescriptionIndex == null) {
  //       this.prescriptionIndex = presIndex;
  //     }

  //     if (this.editItem != undefined) {
  //       this.editItem = undefined;
  //     }
  //     this.editItem = _.cloneDeep(item);
  //   } catch (error) {
  //     this.logger.addError(error, false);
  //     return;
  //   }
  // }

  // public parentSearchAction(event: PCTableOutputModel) {
  //   try {
  //     switch (event.action) {
  //       case 'Sort':
  //         this.listLoading = true;
  //         if (this.searchRequestModel.orderBy == '') {
  //           this.searchRequestModel.direction = 'asd';
  //         } else if (this.searchRequestModel.orderBy != event.data) {
  //           this.searchRequestModel.direction = 'asd';
  //         } else if (this.searchRequestModel.direction == '') {
  //           this.searchRequestModel.direction = 'asd';
  //         } else if (this.searchRequestModel.direction == 'asd') {
  //           this.searchRequestModel.direction = 'desc';
  //         }

  //         this.searchRequestModel.orderBy = event.data;

  //         this.searchDrug(this.editItem?.stock.brandName!);
  //         break;
  //       case 'Paging':
  //         this.listLoading = true;

  //         this.searchRequestModel.pageNumber = event.data;
  //         this.searchDrug(this.editItem?.stock.brandName!);
  //         break;
  //       case 'PageSize':
  //         this.listLoading = true;
  //         this.searchRequestModel.pageSize = event.data;
  //         this.searchDrug(this.editItem?.stock.brandName!);
  //         break;
  //       case 'SelectItem':
  //         this.selectDrug(event);
  //         break;
  //       case 'Successed':
  //         this.modalSuccessConfirm = false;
  //         break;
  //       default:
  //         break;
  //     }
  //   } catch (error) {
  //     this.logger.addError(error, false);
  //     return;
  //   }
  // }

  // public searchDrug(drugName: string): void {
  //   try {
  //     if (drugName == `` || !drugName) {
  //       return;
  //     }

  //     if (this.modalIsOpen == false) {
  //       this.modalIsOpen = true;
  //     }

  //     let url = `SaleFactor/AdvanceSearch?search=${drugName}`;

  //     if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
  //       return;
  //     }

  //     this.searchData = new PCTableInputModel(
  //       [],
  //       [],
  //       true,
  //       1,
  //       this.searchRequestModel.orderBy,
  //       this.searchRequestModel.direction
  //     );
  //     this.apiService.getAll(new ApiRequestModel(url)).subscribe(
  //       (result) => {
  //         this.logger.addResponseLog(url, result, `Get All`);
  //         if (result.succeeded) {
  //           let firstItemOnPage = 1;
  //           if (result.data?.firstItemOnPage) {
  //             firstItemOnPage = result.data?.firstItemOnPage;
  //           }

  //           this.searchData = new PCTableInputModel(
  //             result.data?.items.map((current) => ({
  //               id: current.id,
  //               count: current.count,
  //               lot: current.lot,
  //               expierDate: current.expierDate,
  //               stockId: current.stockId,
  //               stockItemId: current.id,
  //               stockName: current.stockName,
  //               drugId: current.drugId,
  //               drugGenricName: current.drugGenricName,
  //               drugGenricCode: current.drugGenricCode,
  //               drugBrandName: current.drugBrandName,
  //               drugBrandPersianName: current.drugBrandPersianName,
  //               country: current.country,
  //               sellPrice: current.sellPrice,
  //               minimumCount: current.minimumCount,
  //               minimumDigitalCount: current.minimumDigitalCount,
  //               erxCode: current.erxCode,
  //               drugPackageCount: current.drugPackageCount,
  //               drugPackage: current.drugPackage,
  //               keepingType: current.keepingType,
  //               companyName: current.companyName,
  //               rowColor: current.count == 0 ? 'Danger' : '',
  //             })),
  //             [],
  //             true,
  //             firstItemOnPage,
  //             this.searchRequestModel.orderBy,
  //             this.searchRequestModel.direction
  //           );

  //           this.searchPaging = this.responseService.customizePaging(result);
  //         } else {
  //           this.logger.addBackEndMessage(result);
  //         }
  //       },
  //       (error) => {
  //         this.apiService.AddErrorLog(error);
  //         this.listLoading = false;
  //       },
  //       () => {}
  //     );
  //   } catch (e) {
  //     this.logger.addException(e, true);
  //     this.listLoading = false;
  //   }
  // }

  // public selectDrug(event: PCTableOutputModel) {
  //   try {
  //     const selectItem = event.data;
  //     if (this.editItem == null) {
  //       this.logger.addError('خطایی رخ داده صفحه را به روز کنید ', false);
  //       return;
  //     }
  //     if (selectItem.count == 0) {
  //       this.logger.addError(
  //         'موجودی این کالا صفر است و امکان انتخاب برای فروش را ندارد',
  //         false
  //       );
  //       return;
  //     }
  //     if (this.editItem.stock.saleCount == null) {
  //       this.editItem.stock.saleCount = 1;
  //     }
  //     if (this.editItem.organizationSharePrice == null) {
  //       this.editItem.organizationSharePrice = 0;
  //     }

  //     this.editItem.stock.brandName = selectItem.drugBrandName;
  //     this.editItem.stock.expireDate = selectItem.expierDate;
  //     this.editItem.stock.inventoryCount = selectItem.count;
  //     this.editItem.stock.price =
  //       this.editItem.stock.saleCount * selectItem.sellPrice;
  //     const patientShare =
  //       this.editItem.stock.price - this.editItem.organizationSharePrice;
  //     this.editItem.stock.patientSharePrice =
  //       patientShare < 0 ? 0 : patientShare;
  //     this.editItem.stock.stockItemId = selectItem.stockItemId;
  //     this.editItem.stock.stockName = selectItem.stockName;

  //     this.activeSearch = false;
  //   } catch (error) {
  //     this.logger.addError(error, false);
  //     return;
  //   }
  // }

  // public saveEditChange() {
  //   try {
  //     if (this.editItem == null) {
  //       this.logger.addError('خطایی رخ داده صفحه را به روز کنید ', false);
  //       return;
  //     }

  //     if (this.prescriptionIndex == null) {
  //       this.logger.addError('خطایی رخ داده صفحه را به روز کنید ', false);
  //       return;
  //     }

  //     let prescription: Prescription =
  //       this.referral.prescriptions[this.prescriptionIndex];
  //     var foundedItem = prescription.drugs.find(
  //       (current) => current.id == this.editItem!.id
  //     );

  //     if (foundedItem == null) {
  //       this.logger.addError('خطایی رخ داده صفحه را به روز کنید ', false);
  //       return;
  //     }

  //     foundedItem.stock = _.cloneDeep(this.editItem.stock);

  //     let selectItem = this.mapDetailToSelect(foundedItem, foundedItem.stock);

  //     if (prescription.selectDrug == null) {
  //       prescription.selectDrug = [];
  //     }
  //     prescription.selectDrug.push(selectItem);

  //     let thisIndex = 0;
  //     for (let index = 0; index < prescription.drugs.length; index++) {
  //       const element = prescription.drugs[index];
  //       if (element.id == foundedItem.id) {
  //         thisIndex = index;
  //         break;
  //       }
  //     }

  //     this.removeFromBaseList(thisIndex, this.prescriptionIndex);

  //     this.editItem = undefined;
  //   } catch (error) {
  //     this.logger.addError(error, false);
  //     return;
  //   }
  // }

  // public closeEditChange() {
  //   try {
  //     this.editItem = undefined;
  //   } catch (error) {
  //     this.logger.addError(error, false);
  //     return;
  //   }
  // }

  // public openModal(content: any) {
  //   try {
  //     this.modalService
  //       .open(content, { ariaLabelledBy: 'modal-basic-title', size: 'xl' })
  //       .result.then(
  //         (result) => {
  //           if (result == 'Save click') {
  //           }
  //           setTimeout(() => {
  //             this.modalIsOpen = false;
  //           }, 1 * 1000);
  //         },
  //         (reason) => {
  //           setTimeout(() => {
  //             this.modalIsOpen = false;
  //           }, 1 * 1000);
  //         }
  //       );
  //   } catch (error) {
  //     this.logger.addError(error, false);
  //     return;
  //   }
  // }

  // public openMessage(item: PrescriptionDrug) {
  //   try {
  //     if (this.messageModalActive != undefined) {
  //       this.messageModalActive = undefined;
  //     }

  //     this.messageModalActive = item.messages;
  //     this.openModal(this.itemMessageModal);
  //   } catch (error) {
  //     this.logger.addError(error, false);
  //     return;
  //   }
  // }

  // private removeFromBaseList(drugIndex: number, presIndex: number) {
  //   try {
  //     let prescription = this.referral.prescriptions[presIndex];

  //     if (prescription == null) {
  //       this.logger.addError(
  //         'خطایی رخ داده صفحه را به روز رسانی نمایید',
  //         false
  //       );
  //       return;
  //     }

  //     let drug = prescription.drugs[drugIndex];

  //     if (drug == null) {
  //       this.logger.addError(
  //         'خطایی رخ داده صفحه را به روز رسانی نمایید',
  //         false
  //       );
  //       return;
  //     }

  //     if (drug.requestCount == null) {
  //       drug.requestCount = 1;
  //     }

  //     if (drug.stock.saleCount == null) {
  //       drug.stock.saleCount = 1;
  //     }

  //     if (drug.stock.saleCount == drug.requestCount) {
  //       prescription.drugs.splice(drugIndex, 1);
  //     } else {
  //       drug.requestCount = drug.requestCount - drug.stock.saleCount;
  //       drug.stock = new PrescriptionDrugStock();
  //       drug.isSelected = true;
  //     }
  //   } catch (error) {
  //     this.logger.addError(error, false);
  //     return;
  //   }
  // }

  // private removeFromSaleFactor(saleIndex: number, presIndex: number) {
  //   try {
  //     let prescription = this.referral.prescriptions[presIndex];

  //     if (prescription == null) {
  //       this.logger.addError(
  //         'خطایی رخ داده صفحه را به روز رسانی نمایید',
  //         false
  //       );
  //       return;
  //     }

  //     let saleItem = prescription.selectDrug[saleIndex];

  //     if (saleItem == null) {
  //       this.logger.addError(
  //         'خطایی رخ داده صفحه را به روز رسانی نمایید',
  //         false
  //       );
  //       return;
  //     }

  //     let findOriginalItem = prescription.originalDrugs.find(
  //       (current) => current.id == saleItem.id
  //     );

  //     if (findOriginalItem == null) {
  //       this.logger.addError(
  //         'خطایی رخ داده صفحه را به روز رسانی نمایید',
  //         false
  //       );
  //       return;
  //     }

  //     let drugItem = prescription.drugs.find(
  //       (current) => current.id == saleItem.id
  //     );

  //     prescription.selectDrug.splice(saleIndex, 1);

  //     if (drugItem != null) {
  //       prescription.drugs.splice(prescription.drugs.indexOf(drugItem), 1);
  //     }

  //     prescription.drugs.push(findOriginalItem);
  //   } catch (error) {
  //     this.logger.addError(error, false);
  //     return;
  //   }
  // }

  // public print() {
  //   try {
  //     if (this.referral.isShow != true || this.prescriptionIndex == null) {
  //       this.logger.addError('نسخه انتخاب نشده است', false);
  //       return;
  //     }

  //     if (
  //       this.referral.prescriptions[this.prescriptionIndex].selectDrug ==
  //         null ||
  //       this.referral.prescriptions[this.prescriptionIndex].selectDrug.length ==
  //         0
  //     ) {
  //       this.logger.addError('دارویی برای ثبت تعریف نشده است', false);
  //       return;
  //     }
  //     this.recept = this.convertToRecept();
  //     if (this.recept == null) {
  //       this.logger.addError('خطایی رخ داده است ', false);
  //       return;
  //     }

  //     this.loading = true;

  //     setTimeout(() => {
  //       this.loading = false;
  //       this.receptModalIsOpen = true;
  //     }, 2000);
  //   } catch (error) {
  //     this.logger.addError(error, false);
  //     return;
  //   }
  // }

  // private convertToRecept(): any {
  //   try {
  //     if (this.referralRequest.patientNationalCode == null) {
  //       this.logger.addError('کد ملی بیمار الزامی است ', false);
  //       return null;
  //     }

  //     if (
  //       this.referral.prescriptionDate == null ||
  //       this.prescriptionIndex == null ||
  //       this.referralRequest.patientNationalCode == null ||
  //       this.referral.patientName == null ||
  //       this.referral.doctorName == null
  //     ) {
  //       return null;
  //     }

  //     let insuranceAmount = 0;
  //     let totalAmount = 0;
  //     let patientAmount = 0;

  //     this.referral.prescriptions[this.prescriptionIndex].selectDrug.forEach(
  //       (element) => {
  //         if (element.insuranceSharePrice == null) {
  //           element.insuranceSharePrice = 0;
  //         }
  //         insuranceAmount += element.insuranceSharePrice;

  //         if (element.price == null) {
  //           element.price = 0;
  //         }
  //         totalAmount += element.price;

  //         if (element.patientSharePrice == null) {
  //           element.patientSharePrice = 0;
  //         }
  //         patientAmount += element.patientSharePrice;
  //       }
  //     );
  //     let recept = new Recept(
  //       this.referral.prescriptionDate,
  //       this.referralRequest.patientNationalCode,
  //       this.referral.patientName,
  //       this.referral.doctorName,
  //       insuranceAmount,
  //       totalAmount + 20000,
  //       patientAmount,
  //       20000,
  //       20000,
  //       totalAmount,
  //       patientAmount,
  //       0
  //     );

  //     recept.drugList = this.referral.prescriptions[
  //       this.prescriptionIndex
  //     ].selectDrug.map((current) => ({
  //       drugBranName: current.brandName,
  //       count: current.count,
  //       sellPrice: current.price,
  //       insurancePrice: current.insuranceSharePrice,

  //       totalPrice: current.price,
  //       shareCurrencyPrice: current.patientSharePrice,
  //     }));

  //     return recept;
  //   } catch (error) {
  //     this.logger.addError(error, false);
  //     return;
  //   }
  // }

  // public printParentAction(event: PCTableOutputModel) {
  //   try {
  //     switch (event.action) {
  //       case 'ClosePrintModal':
  //         this.referral = new Referral();
  //         this.referral.isShow = false;
  //         this.recept = null;
  //         this.referralRequest = new ReferralRequest();
  //         this.receptModalIsOpen = false;
  //         break;
  //       default:
  //         break;
  //     }
  //   } catch (error) {
  //     this.logger.addError(error, false);
  //     return;
  //   }
  // }

  // public rowClick(item: PrescriptionDrug, presIndex: number) {
  //   try {
  //     if (item.isSelected != true) {
  //       this.openEdit(item, presIndex);
  //     }
  //   } catch (error) {
  //     this.logger.addError(error, false);
  //     return;
  //   }
  // }

  // public selectToUploadBarcode(thisItem: any) {
  //   try {
  //     this.uploadBarcodeItem = thisItem;

  //     setTimeout(() => {
  //       this.openModal(this.ScanBarcodeModal);
  //     }, 100);
  //   } catch (error) {
  //     this.logger.addError(error, false);
  //     return;
  //   }
  // }

  // public parentBarcodeAction(event: PCTableOutputModel) {
  //   try {
  //     switch (event.action) {
  //       case 'SaveUid':
  //         if (this.uploadBarcodeItem == null) {
  //           return;
  //         }

  //         if (this.uploadBarcodeItem.barcode != event.data) {
  //           this.uploadBarcodeItem.barcode = event.data;
  //         }
  //         this.modalService.dismissAll();
  //         this.uploadBarcodeItem = _.cloneDeep(undefined);

  //         break;

  //       case 'closeUid':
  //         this.uploadBarcodeItem = undefined;
  //         this.modalService.dismissAll();
  //         break;

  //       default:
  //         break;
  //     }
  //   } catch (error) {
  //     this.logger.addError(error, false);
  //     return;
  //   }
  // }

  // public DeliveringPrescription() {
  //   try {
  //     const url = `SaleElectronicPrescription/DeliveringPrescription`;
      
  //     let prescription = this.referral.prescriptions.find(
  //       (current) => current.selectDrug != null && current.selectDrug.length > 0
  //     );
      
  //     if (prescription == null) {
  //       this.logger.addError('DontSelectDrugElecPresc', false);
  //       return;
  //     }
  //     this.loading = true;
      
  //     let drugList: any[] = [];

  //     prescription.selectDrug.forEach((element) => {
  //       const drug = {
  //         organizationId: element.organizationId,
  //         phaDrugPrice: element.price,
  //         totalPrice: element.price,
  //         discount: 0,
  //         genericCode: element.genericCode,
  //         genericCodeString: element.genericName,
  //         requestCount: element.count,
  //         checkDeliverCode: element.checkDeliverCode,
  //         brandName: element.brandName,
  //         drugId: element.drugId,
  //         stockItemId: element.stockItemId,
  //         stockId: element.stockId,
  //         paidPrice: element.patientSharePrice,
  //         orgAmount: element.insuranceSharePrice,
  //         expierDate: element.expireDate,
  //       };

  //       drugList.push(drug);
  //     });
  //     const backendJson = {
  //       token: this.referral.token,
  //       citizenToken: this.referral.citizenToken,
  //       trackingCode: this.referralRequest.trackingCode,
  //       saleFactorType: this.referral.saleFactorType,
  //       nationalCode: this.referralRequest.patientNationalCode,
  //       patientFullName: this.referral.patientName,
  //       prescriptionId: prescription.prescriptionId,
  //       doctorName: this.referral.doctorName,
  //       drugs: drugList,
  //     };

  //     this.apiService.postItem(new ApiRequestModel(url, backendJson)).subscribe(
  //       (result) => {
  //         if (result.succeeded == false) {
  //           this.logger.addBackEndMessage(result);
  //           return;
  //         }
  //         this.modalSuccessConfirm = true;
  //         this.getDetailPrint(result.data.id);
  //       },
  //       (error) => {
  //         this.apiService.AddErrorLog(error);
  //         this.loading = false;
  //       },
  //       () => {
  //         this.loading = false;
  //       }
  //     );
  //   } catch (error) {
  //     this.logger.addError(error, false);
  //   }
  // }

  // public getDetailPrint(itemID: string) {
  //   try {
  //     if (this.recept != null && this.recept.id == itemID) {
  //       this.receptModalIsOpen = true;
  //       return;
  //     }
  //     this.listLoading = true;
  //     let url = `SaleFactor/Print/${itemID}`;
  //     if (!this.apiService.tokenValidation(new ApiRequestModel(url))) {
  //       return;
  //     }

  //     this.apiService.getSingleItem(new ApiRequestModel(url)).subscribe(
  //       (result) => {
  //         this.logger.addResponseLog('SaleFactor', result, `Get All`);
  //         if (result.succeeded) {
  //           this.recept = result.data;
  //           this.receptModalIsOpen = true;
  //         } else {
  //           this.logger.addBackEndMessage(result);
  //         }
  //         this.listLoading = false;
  //       },
  //       (error) => {
  //         this.apiService.AddErrorLog(error);
  //         this.listLoading = false;
  //       },
  //       () => {
  //         this.listLoading = false;
  //       }
  //     );
  //   } catch (e) {
  //     this.logger.addException(e, true);
  //     this.listLoading = false;
  //   }
  // }
}
